import { Primary } from '@decorators/entity-primary.decorator';
import { Required } from '@decorators/entity-required.decorator';

import { Entity } from './entity.class';

import { Client } from './client.class';
import { Address } from './address.class';
import { Rapport } from './rapport.class';

export class Bi implements Entity {
	@Required
	@Primary
	id: number;

	@Required
	idTechKalitics: string;
	idBeAzure: string;
	idBaAzure: string;

	@Required
	nomTechKalitics: string;
	nomBeAzure: string;
	nomBaAzure: string;

	@Required
	idTaskKalitics: string;

	@Required
	code: string;

	@Required
	agence: string;

	@Required
	dateIntervention: Date;

	dateContact: Date;
	dateValidationTech: Date | null;
	dateValidationBe: Date | null;
	dateValidationBa: Date | null;

	// Annulation (ATLAS-117) : isClosed = drapeau annulé ; le reste trace le contexte.
	isClosed: boolean;
	cancellationReason: string | null;
	cancelledAt: Date | null;
	cancelledBy: string | null;

	franchise: number;

	nomAssisteur: string;

	assurance: string;

	expertAssurance: string;

	evenementAssurance: string;

	referenceAssisteur: string;

	referenceExpert: string;

	typeInter: string;

	montantHT: number;

	montantTTC: number;

	@Required
	client: Client;

	@Required
	addressFacturation: Address;

	@Required
	addressChantier: Address;

	rapport: Rapport;
	rapportId: number;

	isSynced: boolean;	

	idProjectKalitics: string;
}